import SlsCondicaoPagamentoClient from '@/api/SistemaDKP/sls-condicao-pagamento.client';
import Store from '@/store';

import { ErrorMessage } from '@/libs/Error';

export default class SLSCondicaoPagamentoService {
  constructor() {
    this.client = new SlsCondicaoPagamentoClient();
    this.error = new ErrorMessage();
    this.store = Store;
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async indexFilters(queries = {}) {
    try {
      const {
        data, total, page, perPage, ...otherPaginationData
      } = await this.client.indexFilters(queries);
      this.store.commit('SLSCondicaoPagamento/SET_COND_PAGTOS', data);
      this.store.commit('SLSCondicaoPagamento/SET_FILTERS', {
        ...queries,
        total,
        page,
        perPage,
        ...otherPaginationData,
      });
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os itens');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Condicao Pagamento');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Condicao Pagamento');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Condicao Pagamento');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Condicao Pagamento');
    }
  }

  async geUltimoCondPagPedidoCliente(clienteId, queires = this.store.getters['SLSCondicaoPagamento/GET_FILTERS']) {
    try {
      const { data, ...pagination } = await this.client.geUltimoCondPagPedidoCliente(clienteId, queires);
      this.store.commit('SLSCondicaoPagamento/SET_COND_PAGTOS', data);
      this.store.commit('SLSCondicaoPagamento/SET_FILTERS', { ...queires, ...pagination });
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Condicao Pagamento');
    }
  }

  async GetCondPagtoByClienteId(clienteId, queires = { page: 1, perPage: 8 }) {
    try {
      const { data, ...pagination } = await this.client.GetCondPagtoByClienteId(clienteId, queires);
      this.store.commit('SLSCondicaoPagamento/SET_COND_PAGTOS', data);
      this.store.commit('SLSCondicaoPagamento/SET_FILTERS', { ...queires, ...pagination });
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Condicao Pagamento');
    }
  }

  async GetCondPagtoByRepresentanteId(representanteId, queires = this.store.getters['SLSCondicaoPagamento/GET_FILTERS']) {
    try {
      const { data, ...pagination } = await this.client.GetCondPagtoByRepresentanteId(representanteId, queires);
      this.store.commit('SLSCondicaoPagamento/SET_COND_PAGTOS', data);
      this.store.commit('SLSCondicaoPagamento/SET_FILTERS', { ...queires, ...pagination });
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Condicao Pagamento');
    }
  }
}
